import React from 'react'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'

Bugsnag.start({
    apiKey: '81dffaf6b0bb397966fc79d15481a230',
    plugins: [new BugsnagPluginReact(React)],
    enabledReleaseStages: ['production']
})

export default Bugsnag.getPlugin('react')?.createErrorBoundary()
